import React, { useEffect, useState, useRef } from "react";
import { Header } from "semantic-ui-react";
import CustomIcon from "../../../Assets/Icons/marker_white.svg";
import CustomIconMarker from "../../../Assets/Icons/marker.svg";

import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../config/i18n/slice";

import Add from "./add";
import Edit from "./edit";

import Preview from "./preview/index";

import Filters from "./filters";
import { LocationIcon, PlusIcon } from "../../../Assets/Icons/svg";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import { fetchLocationsInitData } from "../../../redux/reducers/locationReducer";
import { useDebounce } from "use-debounce";
import Animation from "../../components/common/CustomLoader";

const MapViewLocations = ({ google }) => {
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const [defaultCenter, setDefaultCenter] = useState({
    lat: 32.0503808,
    lng: 35.8776832,
  });
  const t = useSelector(selectTranslations);
  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });
  const [hasMapRendered, setHasMapRendered] = useState(true);

  const currentUserId = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.id;
    } else {
      return null;
    }
  });
  const [parentIds, setParentIds] = useState([]);
  const role = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });

  const allIds = [];

  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!allIds.some((inv) => inv == location?.id)) {
        allIds.push(location?.id);
      }

      location.subLocations.forEach((subLocation) => {
        if (!allIds.some((inv) => inv == subLocation?.id)) {
          allIds.push(subLocation?.id);
        }
      });
    });
  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const { userPermissions } = usePermissionsSimplified();
  const [fetching, setFetchLoading] = useState(true);
  const [assetUploadModal, setAssetUploadModal] = useState(false);
  const dispatch = useDispatch();
  const [targetedData, setTargetedData] = useState();
  const [togglePreview, setTogglePreviw] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);

  const [refresh, setRefresh] = useState(false);

  const {
    data,
    isLoading: loading,
    error,
    initData,
    page,
    pageSize,
    total,
    initLoading,
  } = useSelector((state) => ({
    data: state.location.allLocationData,
    isLoading: state.location.allLoading,
    error: state.location.error,
    initData: state.location.locationInitData,
    page: state.location.page,
    pageSize: state.location.pageSize,
    total: state.location.total,
    initLoading: state.location.initLoading,
  }));

  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const [map, setMap] = useState(null);

  const propertyTypeOptions = [
    {
      key: 0,
      value: "Office Buildings",
      text: t.locations.propertyType.officeBuildings,
    },
    {
      key: 1,
      value: "Industrial Facilities",
      text: t.locations.propertyType.industrialFacilities,
    },
    {
      key: 2,
      value: "Retail Spaces",
      text: t.locations.propertyType.retailSpaces,
    },
    {
      key: 3,
      value: "Educational Institutions",
      text: t.locations.propertyType.educationalInstitutions,
    },
    {
      key: 4,
      value: "Healthcare Facilities",
      text: t.locations.propertyType.healthcareFacilities,
    },
    {
      key: 5,
      value: "Residential Buildings",
      text: t.locations.propertyType.residentialBuildings,
    },
    {
      key: 6,
      value: "Hotels and Hospitality",
      text: t.locations.propertyType.hotelsAndHospitality,
    },
    {
      key: 7,
      value: "Government Buildings",
      text: t.locations.propertyType.governmentBuildings,
    },
    {
      key: 8,
      value: "Data Centers",
      text: t.locations.propertyType.dataCenters,
    },
    {
      key: 9,
      value: "Sports and Recreation Facilities",
      text: t.locations.propertyType.sportsAndRecreationFacilities,
    },
    {
      key: 10,
      value: "Cultural Institutions",
      text: t.locations.propertyType.culturalInstitutions,
    },
    {
      key: 11,
      value: "Transportation Hubs",
      text: t.locations.propertyType.transportationHubs,
    },
    {
      key: 12,
      value: "Laboratories",
      text: t.locations.propertyType.laboratories,
    },
    {
      key: 13,
      value: "Agricultural Facilities",
      text: t.locations.propertyType.agriculturalFacilities,
    },
    {
      key: 14,
      value: "Correctional Facilities",
      text: t.locations.propertyType.correctionalFacilities,
    },
    {
      key: 15,
      value: "Utilities and Energy Facilities",
      text: t.locations.propertyType.utilitiesAndEnergyFacilities,
    },
    {
      key: 16,
      value: "Commercial Parking Structures",
      text: t.locations.propertyType.commercialParkingStructures,
    },
    {
      key: 17,
      value: "Mixed-Use Developments",
      text: t.locations.propertyType.mixedUseDevelopments,
    },
    {
      key: 18,
      value: "Telecommunication Facilities",
      text: t.locations.propertyType.telecommunicationFacilities,
    },
    {
      key: 19,
      value: "Financial Institutions",
      text: t.locations.propertyType.financialInstitutions,
    },
    {
      key: 20,
      value: "Government Housing",
      text: t.locations.propertyType.governmentHousing,
    },
    {
      key: 21,
      value: "Religious Buildings",
      text: t.locations.propertyType.religiousBuildings,
    },
    {
      key: 22,
      value: "Shopping Centers",
      text: t.locations.propertyType.shoppingCenters,
    },
    {
      key: 23,
      value: "Technology and Innovation Hubs",
      text: t.locations.propertyType.technologyAndInnovationHubs,
    },
    {
      key: 24,
      value: "Entertainment Venues",
      text: t.locations.propertyType.entertainmentVenues,
    },
  ];
  const [filterOptions, setFilterOptions] = useState({
    customers: [],
    countries: [],
    cities: [],
    createdByUser: [],
    createdAt: {
      value: 0,
      text: t.locations.filter.createdAt,
    },
    priority: [],
    status: [],
  });

  const [searchTitle, setSearchTitle] = useState("");
  const [loader, setloader] = useState(false);
  const [debounceValue] = useDebounce(searchTitle, 500);

  useEffect(() => {
    const fetchData = async () => {
     
      const fetchData = await dispatch(
        fetchLocationsInitData({
          organisationId,
          role,
 
        })
      );
      if (fetchData) {
        setFetchLoading(false);
      }
    };

    fetchData();
  }, [refresh]);
  const mapRef = useRef(null); // Reference for the map div

  useEffect(() => {
    if (window.google && window.google.maps && mapRef.current) {
      const mapInstance = new window.google.maps.Map(mapRef.current, {
        zoom: 12,
        center: defaultCenter,
      });

      setMap(mapInstance);
      const usedPositions = new Map();
      const circlesAndMarkers = data?.map((el) => {
        let markerPosition = {
          lat: el?.attributes?.mainLocation?.lat,
          lng: el?.attributes?.mainLocation?.lng,
        };

        const posKey = `${markerPosition.lat},${markerPosition.lng}`;
      let offsetCount = usedPositions.get(posKey) || 0;


      if (offsetCount > 0) {
        const offset = 0.0005 * offsetCount;
        markerPosition = {
          lat: markerPosition.lat + offset,
          lng: markerPosition.lng + offset,
        };
      }

      // Update used positions
      usedPositions.set(posKey, offsetCount + 1);
        const adjustSizes = (zoom) => {
          const baseRadius = 1000;
          const baseIconSize = 20;
          const scaleFactor = Math.pow(2, zoom - 12);
          const adjustedRadius = baseRadius / scaleFactor;
          const adjustedIconSize = baseIconSize / scaleFactor;
          return { adjustedRadius, adjustedIconSize };
        };

        const updateSize = () => {
          const zoom = mapInstance.getZoom();
          const { adjustedRadius } = adjustSizes(zoom);

          circle.setRadius(1000);
          marker.setIcon({
            url: CustomIconMarker,
            scaledSize: new window.google.maps.Size(30, 30),
          });
        };

        const circle = new window.google.maps.Circle({
          strokeColor: "#0C66E433",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#0C66E433",
          fillOpacity: 0.8,
          map: mapInstance,
          center: markerPosition,
        });

        const marker = new window.google.maps.Marker({
          position: markerPosition,
          map: mapInstance,
          icon: {
            url: CustomIconMarker,
            scaledSize: new window.google.maps.Size(30, 30),
          },
        });

        const infoContent = `
           <div style="font-size: 12px; color: #172B4D; font-weight:500; position: relative; margin-top: 15px;">
       <strong>${el?.attributes?.name}</strong> &nbsp;
           
      </div>
        `;
        const infoWindow = new window.google.maps.InfoWindow({
          content: infoContent,
          disableAutoPan: true,
          pixelOffset: new window.google.maps.Size(0, -10),
        });

        marker.addListener("mouseover", () => {
          marker.setIcon({
            url: CustomIcon,
            scaledSize: new window.google.maps.Size(30, 30),
          });
          circle.setOptions({
            fillColor: "#0C66E4",
          });
          infoWindow.open(mapInstance, marker);
        });

        marker.addListener("mouseout", () => {
          marker.setIcon({
            url: CustomIconMarker,
            scaledSize: new window.google.maps.Size(30, 30),
          });
          circle.setOptions({
            fillColor: "#0C66E433",
          });
          infoWindow.close();
        });

        marker.addListener("click", () => {
          setTargetedData(el);
          setTogglePreviw(true);
        });

        window.google.maps.event.addListenerOnce(infoWindow, "domready", () => {
          const closeButton = document.getElementById("close-icon");
          if (closeButton) {
            closeButton.addEventListener("click", () => {
              infoWindow.close();
            });
          }
        });

        updateSize();

        return () => {
          window.google.maps.event.clearListeners(mapInstance, "zoom_changed");
          marker.setMap(null);
          circle.setMap(null);
        };
      });
      setHasMapRendered(false);
    }
  }, [data]);

  const style = {
    width: "100%",
    height: "100%",
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "800px",
  };

  const handleSetDataByFilter = (newData) => {};

  return (
    <>
      <div className="new-listing-container table-header-dashboard stick-header pb-5">
        <div className="header-actions">
          <Header className="procedure-title mt-5" as="h2">
            {" "}
            <LocationIcon />
            {t.locations.title}
          </Header>
          <div></div>

          {userPermissions?.location?.create ? (
            <button
              onClick={() => {
                setToggleAsideModal(true);
              }}
              type="button"
              className="add-button location"
            >
              <span className="add-button-text"> {t.locations.add}</span>
              <span className="add-button-img">
                <PlusIcon />
              </span>
            </button>
          ) : null}
        </div>
        {!initLoading ? (
          <div className="new-listing-filter wo-filter sticky-filter mt-8">
            <Filters
              data={initData}
              setAssetUploadModal={setAssetUploadModal}
              assetUploadModal={assetUploadModal}
              setDataByFilter={handleSetDataByFilter}
              hasStatus={false}
              fileData={data}
              setFilterOptions={setFilterOptions}
              filterOptions={filterOptions}
              setloader={setloader}
              loader={loader}
              role={role}
              allIds={allIds}
              parentIds={parentIds}
              currentUserId={currentUserId}
              setSearchTitle={setSearchTitle}
              searchTitle={searchTitle}
              debounceValue={debounceValue}
            />
          </div>
        ) : null}
      </div>
      <div className="new-listing-container">
        {initLoading || loading ? (
          <div className="d-flex animation-div justify-content-center align-items-center">
            <Animation />
          </div>
        ) : (
          <div>
            <div className="new-listing-filter">
              <>
                <div id="map" ref={mapRef} style={containerStyle}></div>
              </>
            </div>
          </div>
        )}

        <Add
          toggled={toggleAsideModal}
          untoggle={() => {
            setToggleAsideModal(false);
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          allIds={allIds}
          parentIds={parentIds}
          role={role}
          currentUserId={currentUserId}
        />

        <Edit
          targetedData={targetedData}
          toggled={toggleEditModal}
          refresh={refresh}
          setRefresh={setRefresh}
          allIds={allIds}
          parentIds={parentIds}
          role={role}
          currentUserId={currentUserId}
          untoggle={() => {
            setToggleEditModal(false);
          }}
        />

        <Preview
          targetedData={targetedData}
          propertyTypeOptions={propertyTypeOptions}
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          toggled={togglePreview}
          refresh={refresh}
          setRefresh={setRefresh}
          edit={() => {
            setTogglePreviw(false);
            setToggleEditModal(true);
          }}
          untoggle={() => {
            setTargetedData();
            setTogglePreviw(false);
          }}
        />
      </div>
    </>
  );
};

export default MapViewLocations;
